import React, { useState } from "react";

import {
	Badge,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Fab,
	Zoom,
	useTheme
} from "@material-ui/core";
import { useNavigate } from "react-router";

import CartDrawer from "containers/CartDrawer";
import CartItemDrawer from "containers/CartItemDrawer";
import CheckoutDrawer from "containers/CheckoutDrawer";
import CompanyInfoDrawer from "containers/CompanyInfoDrawer";
import MenuItemDrawer from "containers/MenuItemDrawer";
import MessageDrawer from "containers/MessageDrawer";
import MobileContainerDrawer from "containers/MobileContainerDrawer";

import makeStyles from "hooks/makeStyles";
import useBusiness from "hooks/useBusiness";
import useCart from "hooks/useCart";
import useTranslation from "hooks/useTranslation";
import CartIcon from "icons/CartIcon";

const useStyles = makeStyles(theme => ({
	fab: {
		position: "absolute",
		bottom: theme.spacing(2),
		right: theme.spacing(2),
		backgroundColor: theme.palette.primary.main,
		zIndex: 100
	},
	fabIcon: {
		marginLeft: -2
	},
	badge: {
		top: -20,
		right: -4
	}
}));

const BottomDrawers = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const classes = useStyles();
	const theme = useTheme();
	const [error, setError] = useState();

	const { cartItemsCount, isConfirmationVisible } = useCart();
	const { business } = useBusiness();

	const onCartClicked = () => {
		if (business.pause) {
			setError(t("Pausing", { name: business.name }));
		} else {
			navigate("#cart");
		}
	};

	const transitionDuration = {
		enter: theme.transitions.duration.enteringScreen,
		exit: theme.transitions.duration.leavingScreen
	};

	return (
		<>
			<MenuItemDrawer />
			<CartDrawer />
			<CartItemDrawer />
			<CheckoutDrawer />
			<MessageDrawer open={isConfirmationVisible} />
			<CompanyInfoDrawer />
			<MobileContainerDrawer>
				{cartItemsCount > 0 && (
					<Zoom
						in={true}
						timeout={transitionDuration}
						style={{
							position: "fixed",
							transitionDelay: `${transitionDuration.exit}ms`
						}}
						unmountOnExit
					>
						<Fab className={classes.fab} onClick={onCartClicked}>
							<CartIcon fill={theme.palette.primary.contrastText} className={classes.fabIcon} height={24} width={24} />
							<Badge badgeContent={cartItemsCount} color={"secondary"} className={classes.badge} />
						</Fab>
					</Zoom>
				)}
			</MobileContainerDrawer>

			<Dialog
				open={!!error}
				onClose={() => setError(undefined)}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle id="alert-dialog-title">{t("Oppsss")}</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-description">{error}</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={() => setError(undefined)}>{t("Ok")}</Button>
				</DialogActions>
			</Dialog>
		</>
	);
};

export default BottomDrawers;
